import { Controller } from "@hotwired/stimulus"

// The Phone directory's Copy buttons (Phone_Round2_Plan.md, committee
// D-SHOULD 6): the number goes to the clipboard, the button says "Copied"
// for a moment. Numbers are never tel: links (a tap would call from a
// personal cell), so this is how a number leaves the page.
export default class extends Controller {
  static targets = ["note"]

  async copy(event) {
    const button = event.currentTarget
    const number = event.params.number
    try {
      await navigator.clipboard.writeText(number)
      const label = button.textContent
      button.textContent = "Copied"
      setTimeout(() => { button.textContent = label }, 1500)
    } catch (_e) {
      // No clipboard (an old browser, or a page not served over HTTPS):
      // show the number as plain text to select by hand. Never a browser
      // prompt (house rule: no confirm, alert or prompt dialogs).
      if (this.hasNoteTarget) {
        this.noteTarget.textContent = `Couldn't copy. The number is ${number}.`
        this.noteTarget.hidden = false
      }
    }
  }
}
